// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2qNrm","right":"Footer_right__idoC1","buttons":"Footer_buttons__3yzpK"};